/* /src/components/auth/logout.jsx */

import React from "react";
import { AuthConsumer } from '../../contexts/authProvider';
import LoadingIndicator from '../wrapper/LoadingIndicator/LoadingIndicator';

export const Logout = () => (
    <AuthConsumer>
        {({ logout }) => {
            logout();
            return <LoadingIndicator active={true} />;
        }}
    </AuthConsumer>
);